/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import React from 'react';
import { TestToolProps } from './TestTool.props';
import { isGenerative } from '../../Utilities/formPredicates';
import { GenerativeTest } from './variants/GenerativeTest';
import { ChatbotTest } from './variants/ChatbotTest';

export const TestTool = ({ contentTool }: TestToolProps): JSX.Element => {
  return isGenerative(contentTool.type) ? (
    <GenerativeTest contentTool={contentTool} />
  ) : (
    <ChatbotTest contentTool={contentTool} />
  );
};
